import moment from "moment";
import { Link } from "react-router-dom";
import { isDaysDifference } from "../../../utilities/commonUtilities";

interface recentProjects {
    handleNavigate?: any;
}

export const recentProject = ({ handleNavigate }: recentProjects) => [
    {
        title: "Project",
        dataIndex: "projectName",
        key: "projectName",
        sortable: false,
        render: (
            text: string,
            record: {
                new: boolean;
                createdOn: string;
                updatedOn: string;
                projectName: string;
                projectId: string;
                status: string;
            }
        ) => (
            <div className="flex items-center">
                <p onClick={() => handleNavigate(record)}>
                    <p className="text-[14px] text-primary-400 cursor-pointer truncat  hover:underline focus:underline active:underline">
                        {text}
                    </p>
                </p>
                <div className="ml-2">
                    {
                        record?.status === "Acknowldged" ?
                            <div className="border text-center px-1  border-success-400 rounded text-success-400" >
                                Acknowledged
                            </div >
                            : record?.status === "NeedReview" &&
                            <div className="border text-center px-1 border-lightorange-500 rounded text-lightorange-500" >
                                Need review
                            </div >
                    }
                </div>
            </div>
        ),
    },
    {
        title: "Location",
        dataIndex: "location",
        key: "location",
        sortable: false,
        render: (_: string, record: { country: string; state: string, county: string }) => (
            <div className="text-neutral-25 text-[14px] truncate">
                {record.country}
                {record.state ? `, ${record.state}` : ""}
                {record.county ? `, ${record.county}` : ""}
            </div>
        ),
    },
    {
        title: "Modified",
        dataIndex: "updatedOn",
        key: "updatedOn",
        sortable: false,
        render: (text: string) => (
            <div className="truncate text-[14px]">
                {moment(text).format("Do MMM YYYY hh:mm a")}
            </div>
        ),
    },
];

export const CustomerFeedback = ({ handleNavigate }: recentProjects) => [
    {
        title: "Project",
        dataIndex: "projectName",
        key: "projectName",
        sortable: false,
        render: (
            text: string,
            record: {
                new: boolean;
                createdOn: string;
                updatedOn: string;
                projectName: string;
                projectId: string;
                status: string;
            }
        ) => (
            <div className="flex items-center">
                <p onClick={() => handleNavigate(record)}>
                    <p className="text-[14px] text-primary-400 cursor-pointer truncat  hover:underline focus:underline active:underline">
                        {text}
                    </p>
                </p>
                <div className="ml-2">
                    {
                        record?.status === "Acknowldged" ?
                            <div className="border text-center px-1  border-success-400 rounded text-success-400" >
                                Acknowledged
                            </div >
                            : record?.status === "NeedReview" &&
                            <div className="border text-center px-1 border-secondary-400 rounded text-secondary-400" >
                                Need review
                            </div >
                    }
                </div>
            </div>
        ),
    },
    {
        title: "Location",
        dataIndex: "location",
        key: "location",
        sortable: false,
        render: (_: string, record: { country: string; state: string, county: string }) => (
            <div className="text-neutral-25 text-[14px] truncate">
                {record.country}
                {record.state ? `, ${record.state}` : ""}
                {record.county ? `, ${record.county}` : ""}
            </div>
        ),
    },
    {
        title: "Modified",
        dataIndex: "updatedOn",
        key: "updatedOn",
        sortable: false,
        render: (text: string) => (
            <div className="truncate text-[14px]">
                {moment(text).format("Do MMM YYYY hh:mm a")}
            </div>
        ),
    },
];

export const userRecentProject = [
    {
        title: "Project",
        dataIndex: "projectName",
        key: "projectName",
        sortable: false,
        width: "25%",
        render: (
            text: string,
            record: {
                new: boolean;
                createdOn: string;
                updatedOn: string;
                projectName: string;
                projectId: string;
            }
        ) => (
            <div className="flex items-center">
                <Link to={`/project-details/${record?.projectId}`}>
                    <p className="text-[14px] text-primary-400 cursor-pointer truncat  hover:underline focus:underline active:underline">
                        {text}
                    </p>
                </Link>

                {isDaysDifference(record?.updatedOn, 7) && (
                    <div className="ml-2 flex items-center rounded text-[14px] border py-1 px-2 text-success-400 border-success-400 font-semibold">
                        New
                    </div>
                )}
            </div>
        ),
    },
    {
        title: "Location",
        dataIndex: "location",
        key: "location",
        sortable: false,
        width: "25%",
        render: (_: string, record: { country: string; state: string }) => (
            <div className="text-neutral-25 text-[14px]">
                {record.country}
                {record.state ? `, ${record.state}` : ""}
            </div>
        ),
    },
    {
        title: "Modified",
        dataIndex: "updatedOn",
        key: "updatedOn",
        sortable: false,
        width: "25%",
        render: (text: string) => (
            <div>{moment(text).format("MMM Do, YYYY hh:mm a")}</div>
        ),
    },
];
